<template>
  <section>
    <h2>Button 按钮</h2>
    <p class="desc">基础组件，触发业务逻辑时使用。</p>
    <h2>基础用法</h2>
    <div class="container">
      <div class="example">
        <span class="button-wrapper">
          <y-button>default</y-button>
        </span>
        <span class="button-wrapper">
          <y-button type="primary">primary</y-button>
        </span>
        <span class="button-wrapper">
          <y-button type="warning">warning</y-button>
        </span>
        <span class="button-wrapper">
          <y-button type="error">error</y-button>
        </span>
        <span class="button-wrapper">
          <y-button type="success">success</y-button>
        </span>
        <span class="button-wrapper">
          <y-button type="info">info</y-button>
        </span>
      </div>
      <div class="code-wrapper" v-highlight>
        <pre class="code"><code class="html" v-text="text1"></code></pre>
      </div>
    </div>
    <h2>带有icon</h2>
    <div class="container">
      <div class="example">
        <span class="button-wrapper">
          <y-button icon="settings" type="primary">setting</y-button>
        </span>
        <span class="button-wrapper">
          <y-button icon="settings" type="primary" icon-position="right">setting</y-button>
        </span>
        <span class="button-wrapper">
          <y-button icon="loading" :loading="loading" @click="loading = !loading" type="primary">loading</y-button>
        </span>
      </div>
      <div class="code-wrapper" v-highlight>
        <pre class="code"><code class="html" v-text="text2"></code></pre>
      </div>
    </div>
    <h2>按钮组合</h2>
    <div class="container">
      <div class="example">
        <span class="button-wrapper">
          <y-button-group>
            <y-button type="primary" icon="left">backward</y-button>
            <y-button type="primary" icon="right" icon-position="right">forward</y-button>
          </y-button-group>
        </span>
      </div>
      <div class="code-wrapper" v-highlight>
        <pre class="code"><code class="html" v-text="text3"></code></pre>
      </div>
    </div>
    <h2>Attributes</h2>
    <div class="attr">
      <table>
        <thead>
          <tr>
            <th>参数</th>
            <th>说明</th>
            <th>类型</th>
            <th>可选值</th>
            <th>默认值</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>icon</td>
            <td>icon图标名称</td>
            <td>String</td>
            <td>--</td>
            <td>--</td>
          </tr>
          <tr>
            <td>type</td>
            <td>按钮颜色</td>
            <td>String</td>
            <td>primary,waring,error,success,info</td>
            <td>default</td>
          </tr>
          <tr>
            <td>loading</td>
            <td>带loading效果的按钮</td>
            <td>Boolean</td>
            <td>true/false</td>
            <td>false</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>
<script>
export default {
  data () {
    return {
      text1: `<y-button>default</y-button>
<y-button type="primary">primary</y-button>
<y-button type="warning">warning</y-button>
<y-button type="error">error</y-button>
<y-button type="success">success</y-button>
<y-button type="info">info</y-button>`,
      text2: `<y-button icon="settings" type="primary">setting</y-button>
<y-button icon="settings" type="primary" icon-position="right">setting</y-button>
<y-button icon="loading" :loading="loading" @click="loading = !loading" type="primary">loading</y-button>`,
      text3: `<y-button-group>
  <y-button type="primary" icon="left">backward</y-button>
  <y-button type="primary" icon="right" icon-position="right">forward</y-button>
</y-button-group>`,
      loading: true,
    }
  },
}
</script>
